module.exports = __webpack_public_path__ + "static/media/delete-blue.39e45cd5.png";